import { QueryClient } from '@tanstack/react-query'

const tacticQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Number.POSITIVE_INFINITY,
    },
  },
})

export default tacticQueryClient
